import { BehaviorSubject, Observable } from "rxjs";
import { Injectable } from "@angular/core";
import * as SIP from 'sip.js';
import { Theme } from "./AutoTheme";
import { AUDIOURL } from "../../app-routing.module";
      import { environment } from '../../../environments/environment';
let myTimer;
let session;

@Injectable()
export class SipJsService { 
  private __crmdata = new BehaviorSubject<any>(null);
  public crmdata= this.__crmdata.asObservable();  
  
  public _lastcall = new BehaviorSubject<any>(null);
  public lastcalldata= this._lastcall.asObservable();  

  public isring:boolean=true;

  userAgent: SIP.UA;
  audio:any;
  
  remoteAudio:any = document.getElementById('remoteAudio');
  localAudio:any = document.getElementById('localAudio');

  constructor(private theme:Theme) { 

    this.audio=new Audio();
    this.audio.src=AUDIOURL+"ring11.mp3";   
   }

  public RegisterUA(user:string, pwd:string) : void{
    var config = {    
      uri: user+'@'+environment.SIP_DOMAIN,
      ws_servers: 'wss://'+environment.SIP_DOMAIN+':'+7443,
      authorizationUser: user,   
      password: pwd,    
      transportOptions: {
          traceSip: true,
          wsServers: 'wss://'+environment.SIP_DOMAIN+':'+7443
        },
        registerExpires: 3600
      };

    this.userAgent = new SIP.UA(config);

    let __data = new BehaviorSubject<any>(null);
    let data= __data.asObservable();
    let __color = new BehaviorSubject<any>(null);
    let color= __color.asObservable();


    data.subscribe(rss =>{
      console.log(rss); 
      if(rss != null)
      {      
        this.theme.ChangeSipData(rss);
      }
    });
    
    color.subscribe(rss =>{
      console.log(rss); 
      if(rss != null)
      {      
        this.theme.ChangeColor(rss); 
      }
    });

    this.userAgent.on('registered', function () {    
      __data.next("User Registered"); 
      __color.next("green");    
      console.log("User Register Successfully");
    });

    this.userAgent.on('unregistered', function () {    
      __data.next("User Unregistered"); 
      __color.next("green");      
      console.log("User Unregistered Successfully");
    });
    
    this.userAgent.on('registrationFailed', function () {   
      __data.next("User Registration Failed"); 
      __color.next("warning");   
      console.log("User Register registrationFailed");
    });
   
  } 

  public MakeOutboundCall()
  {
    let prefdata = JSON.parse(sessionStorage.getItem("preferences"));
    let call_recording = prefdata.call_recording;
    var randomno = Math.floor(100000000000000 + Math.random() * 900000000000000);
    var recording_file = sessionStorage.getItem('leadID')+"_"+sessionStorage.getItem("current_number")+"_"+randomno;
    var options = {
      sessionDescriptionHandlerOptions: {
        constraints: {
          audio: true,
          video: false
        }
      },
      extraHeaders: []     
    };    
    console.log("Make call has been Initiated :: "+sessionStorage.getItem("current_number"));
    console.log("###########",sessionStorage.getItem("prefix")+sessionStorage.getItem("country_code")+sessionStorage.getItem("current_number")+'@'+environment.SIP_DOMAIN,options)
    
    if(sessionStorage.getItem("isdev") == "yes")
    {
      session = this.userAgent.invite(sessionStorage.getItem("prefix")+sessionStorage.getItem("country_code")+sessionStorage.getItem("current_number")+'@'+environment.SIP_DOMAIN,options);
    }
    else
    {
      session = this.userAgent.invite(sessionStorage.getItem("prefix")+sessionStorage.getItem("country_code")+sessionStorage.getItem("current_number")+'@'+environment.SIP_DOMAIN,options);
    }
    console.log("session##########",session)
    session.on('progress', (response:any)=>{ 
      console.log(response);
      console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@"+response.statusCode+"@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");      
      console.log(response.reasonPhrase);
      sessionStorage.setItem('isdial', (0).toString());
      if(response.statusCode==100)
      {
        this.isring=true;
        this.theme.ChangeColor('bluedark'); 
        this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Trying");        
      }

      /* if(response.statusCode==180)
      {
         this.isring=false;
        this.audio.load();
        this.audio.play();  
        this.theme.ChangeColor('purple'); 
        this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Ringing");        
      } */

      if(response.statusCode==183)
      {
        /* if(this.isring)
        { */
          this.audio.load();
          this.audio.play(); 
          this.theme.ChangeColor('purple'); 
          this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Ringing");
       // }
        let prefdata = JSON.parse(sessionStorage.getItem("preferences"));
        let ringingtime = parseInt(prefdata.ringing_time);
        if(parseInt(sessionStorage.getItem("isautodial"))==1)
        {
          let count = ringingtime;
         myTimer = setInterval(() => {
            count = (count - 1);
            console.log("Count Down Start :: "+count);
            if (count == 0) { 
                  clearInterval(myTimer);
                  this.theme.StopAutodial(1);
            }
            }, 1000);          
        }
      }
      console.log(response.statusCode);
      console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");
      
      });

      session.on('rejected', (response, cause)=>{ 
        console.log("/@@@@@@@@@@@@@@@@@@@@@@@@"+response.statusCode+"@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");      
        console.log(response.reasonPhrase);
        console.log(response.statusCode); 
        sessionStorage.setItem('isdial', (1).toString());   
        clearInterval(myTimer);  
        this.audio.pause();  
        if(response.statusCode==480)
        {
          this.theme.ChangeColor('warning'); 
          this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Rejected");  
          if(parseInt(sessionStorage.getItem("isdial"))==1)
          {
            this.theme.StartAutodial(1);
          }
        }
        if(response.statusCode==503)
        {
          this.theme.ChangeColor('warning'); 
          this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Rejected");  
          if(parseInt(sessionStorage.getItem("isdial"))==1)
          {
            this.theme.StartAutodial(1);
          }
        }
        if(response.statusCode==408)
        {
          this.theme.ChangeColor('warning'); 
          this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Unavailable");  
          if(parseInt(sessionStorage.getItem("isdial"))==1)
          {
            this.theme.StartAutodial(1);
          }
        }
        if(response.statusCode==488)
        {
          this.theme.ChangeColor('warning'); 
          this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Unavailable");  
          if(parseInt(sessionStorage.getItem("isdial"))==1)
          {
            this.theme.StartAutodial(1);
          }
        }
        if(response.statusCode==486)
        {
          this.theme.ChangeColor('warning'); 
          this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Busy");  
          if(parseInt(sessionStorage.getItem("isdial"))==1)
          {
            this.theme.StartAutodial(1);
          }
        }

        if(response.statusCode==487)
        {
          this.theme.ChangeColor('warning'); 
          this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is No Answer");  
          if(parseInt(sessionStorage.getItem("isdial"))==1)
          {
            this.theme.StartAutodial(1);
          }
        }

        if(response.statusCode==400)
        {
          this.theme.ChangeColor('warning'); 
          this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Unavailable");  
          if(parseInt(sessionStorage.getItem("isdial"))==1)
          {
            this.theme.StartAutodial(1);
          }
        }

        if(response.statusCode==401)
        {
          this.theme.ChangeColor('warning'); 
          this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Unauthorized");  
          if(parseInt(sessionStorage.getItem("isdial"))==1)
          {
            this.theme.StartAutodial(1);
          }
        }

        if(response.statusCode==403)
        {
          this.theme.ChangeColor('warning'); 
          //this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Wrong Number.(EC:"+response.statusCode+")");  
          this.theme.ChangeSipData("User is Unregistered");
          if(parseInt(sessionStorage.getItem("isdial"))==1)
          {
            this.theme.StartAutodial(1);
          }
        }

        if(response.statusCode==404)
        {
          this.theme.ChangeColor('warning'); 
          this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Wrong Number");  
          if(parseInt(sessionStorage.getItem("isdial"))==1)
          {
            this.theme.StartAutodial(1);
          }
        }

        if(response.statusCode==484)
        {
          this.theme.ChangeColor('warning'); 
          this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Wrong Number");  
          if(parseInt(sessionStorage.getItem("isdial"))==1)
          {
            this.theme.StartAutodial(1);
          }
        }
        this.theme.showDialpad(false);
        this.theme.ChangeEvent(0);
       console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");
       
      });
  
      session.on('cancel', ()=>{ 
        sessionStorage.setItem('isdial', (1).toString());
        clearInterval(myTimer);
        this.theme.ChangeColor('warning');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Rejected"); 
        this.theme.showDialpad(false);   
        this.theme.ChangeEvent(0);       
      });
  
      session.on('bye', (request)=>{ 
        console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@"+request.method+"@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");      
        console.log(request.method);
        sessionStorage.setItem('isdial', (1).toString());
        clearInterval(myTimer);
        if(request.method=="BYE")
        {
          this.theme.ChangeColor('red');
          this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Disconnected");
          this.theme.GetBalance(true);
          if(parseInt(sessionStorage.getItem("isdial"))==1)
          {
            this.theme.StartAutodial(1);
          }
        }
        console.log(request.statusCode);
        console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");
        this.theme.GetBalance(true);
        this.theme.showDialpad(false);
        this.theme.ChangeEvent(0);
      });  

    session.on('trackAdded', ()=>{ 
            
    });

    session.on('accepted', (data)=>{ 
      
      console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@"+data.statusCode+"@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");      
      console.log(data.reasonPhrase);
      console.log(data.statusCode);
      clearInterval(myTimer);
      var pc = session.sessionDescriptionHandler.peerConnection;
      sessionStorage.setItem('isdial', (0).toString());
      if(data.statusCode==200)
      {
        this.audio.pause(); 
        this.theme.ChangeColor('green'); 
        this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Connected");
        this.theme.showDialpad(true);

        var remoteStream = new MediaStream();
        pc.getReceivers().forEach(function(receiver) {
          remoteStream.addTrack(receiver.track);
        });
        this.remoteAudio.srcObject = remoteStream;
        this.remoteAudio.play();

        // Gets local tracks
        var localStream = new MediaStream();
        pc.getSenders().forEach(function(sender) {
          localStream.addTrack(sender.track);
        });
        this.localAudio.srcObject = localStream;
        this.localAudio.play();  
        sessionStorage.setItem("phonetype", "0");      
      }
      console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");     
    });    
  }

  public HangupCall()
  {
    session.terminate();    
    this.theme.ChangeColor('red');
    this.audio.pause(); 
    sessionStorage.setItem('isdial', (1).toString());
    this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Disconnected");
    this.theme.showDialpad(false); 
    this.theme.GetBalance(true);
  }

  public SendDTMF(number:string)
  {
    console.log("DTMF");
    console.log(number);
    session.dtmf(number);
    this.theme.ChangeSipData("Send "+number+" IVR to "+sessionStorage.getItem("current_number"));
  }

  public CallTransfer(number:string)
  {
    if(session != null && session !=undefined)
    {
      session.refer(number+'@'+environment.SIP_DOMAIN);
      this.theme.ChangeSipData("Call has been transfered to +"+number);
    }
  }

  public MuteCall()
  {
    console.log("Mute Call");    
    /* session.mute(); */
    var pc = session.sessionDescriptionHandler.peerConnection;
    pc.getLocalStreams().forEach(function (stream) {
        stream.getAudioTracks().forEach(function (track) {
            track.enabled = false;
        });
    });
  }
  
  public UnMuteCall()
  {
    console.log("Un-Mute Call");    
    /* session.unmute(); */
    var pc = session.sessionDescriptionHandler.peerConnection;
    pc.getLocalStreams().forEach(function (stream) {
        stream.getAudioTracks().forEach(function (track) {
            track.enabled = true;
        });
    });
  }

  public HoldCall()
  {
    console.log("Hold Call");    
    session.hold();
  }

  public UnHoldCall()
  {
    console.log("Un-Hold Call");    
    session.unhold();
  }

  public UnregisterUA()
  {   
   this.userAgent.unregister();
  }

  public RecieveSipjsEvents() {
    let data= new BehaviorSubject<any>("");
    let value=data.asObservable();
    session.on('progress', (response)=>{ 
      data.next(response);
     // console.log(response);
      return value;     
    });
    return value;    
  }

  private handleError(error) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
        let errMessage = error.error.message;
        return Observable.throw(errMessage);
    }
    return Observable.throw(error || 'SIP.JS server error');
  }


  // @method for making outbound calling for testing purpose
  public MakeOutboundCallTesting(bwNumber: any) {
    // let prefdata = JSON.parse(sessionStorage.getItem("preferences"));
    // let call_recording = prefdata.call_recording;
    // var randomno = Math.floor(100000000000000 + Math.random() * 900000000000000);
    // var recording_file = sessionStorage.getItem('leadID') + "_" + sessionStorage.getItem("current_number") + "_" + randomno;
    var options = {
      sessionDescriptionHandlerOptions: {
        constraints: {
          audio: true,
          video: false
        }
      },
      // extraHeaders: ["X-CallerID: " + sessionStorage.getItem('callerid'), "X-minute: " + sessionStorage.getItem('minutes'), "X-buyminute: " + sessionStorage.getItem('buy_minutes'), "X-rate: " + sessionStorage.getItem('rate'), "X-leadid: " + sessionStorage.getItem('leadID'), "X-agentid: " + sessionStorage.getItem('userid'), "X-recording: " + recording_file, "X-callrecording: " + call_recording, "X-idcompany: " + sessionStorage.getItem("id_company"), "X-campaign: " + sessionStorage.getItem("currcampaign"), "X-DialedNum: " + sessionStorage.getItem('current_number')]
    };
    console.log("Make call has been Initiated :: " + sessionStorage.getItem("current_number"));

    // if (sessionStorage.getItem("isdev") == "yes") {
    //   session = this.userAgent.invite('1122' + sessionStorage.getItem("current_number") + '@' + sessionStorage.getItem("domain") + '.ninjadialer.com', options);
    // }
    // else {
    //   session = this.userAgent.invite(sessionStorage.getItem("current_number") + '@' + sessionStorage.getItem("domain") + '.ninjadialer.com', options);
    // }
    session = this.userAgent.invite(bwNumber + '@' + environment.SIP_DOMAIN, options);

    session.on('progress', (response: any) => {
      console.log(response);
      console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@" + response.statusCode + "@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");
      console.log(response.reasonPhrase);
      sessionStorage.setItem('isdial', (0).toString());

      if (response.statusCode == 100) {
        this.isring = true;
        this.theme.ChangeColor('bluedark');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Trying");
      }

      /* if(response.statusCode==180)
      {
         this.isring=false;
        this.audio.load();
        this.audio.play();  
        this.theme.ChangeColor('purple'); 
        this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Ringing");        
      } */

      if (response.statusCode == 183) {
        /* if(this.isring)
        { */
        this.audio.load();
        this.audio.play();
        this.theme.ChangeColor('purple');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Ringing");
        // }
        let prefdata = JSON.parse(sessionStorage.getItem("preferences"));
        let ringingtime = parseInt(prefdata.ringing_time);
        if (parseInt(sessionStorage.getItem("isautodial")) == 1) {
          let count = ringingtime;
          myTimer = setInterval(() => {
            count = (count - 1);
            console.log("Count Down Start :: " + count);
            if (count == 0) {
              clearInterval(myTimer);
              this.theme.StopAutodial(1);
            }
          }, 1000);
        }
      }
      console.log(response.statusCode);
      console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");

    });

    session.on('rejected', (response, cause) => {
      console.log("/@@@@@@@@@@@@@@@@@@@@@@@@" + response.statusCode + "@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");
      console.log(response.reasonPhrase);
      console.log(response.statusCode);
      sessionStorage.setItem('isdial', (1).toString());
      clearInterval(myTimer);
      this.audio.pause();

      if (response.statusCode == 480) {
        this.theme.ChangeColor('warning');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Rejected");
        if (parseInt(sessionStorage.getItem("isdial")) == 1) {
          this.theme.StartAutodial(1);
        }
      }
      if (response.statusCode == 503) {
        this.theme.ChangeColor('warning');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Rejected");
        if (parseInt(sessionStorage.getItem("isdial")) == 1) {
          this.theme.StartAutodial(1);
        }
      }
      if (response.statusCode == 408) {
        this.theme.ChangeColor('warning');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Unavailable");
        if (parseInt(sessionStorage.getItem("isdial")) == 1) {
          this.theme.StartAutodial(1);
        }
      }
      if (response.statusCode == 488) {
        this.theme.ChangeColor('warning');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Unavailable");
        if (parseInt(sessionStorage.getItem("isdial")) == 1) {
          this.theme.StartAutodial(1);
        }
      }
      if (response.statusCode == 486) {
        this.theme.ChangeColor('warning');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Busy");
        if (parseInt(sessionStorage.getItem("isdial")) == 1) {
          this.theme.StartAutodial(1);
        }
      }
      if (response.statusCode == 487) {
        this.theme.ChangeColor('warning');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is No Answer");
        if (parseInt(sessionStorage.getItem("isdial")) == 1) {
          this.theme.StartAutodial(1);
        }
      }
      if (response.statusCode == 400) {
        this.theme.ChangeColor('warning');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Unavailable");
        if (parseInt(sessionStorage.getItem("isdial")) == 1) {
          this.theme.StartAutodial(1);
        }
      }
      if (response.statusCode == 401) {
        this.theme.ChangeColor('warning');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Unauthorized");
        if (parseInt(sessionStorage.getItem("isdial")) == 1) {
          this.theme.StartAutodial(1);
        }
      }
      if (response.statusCode == 403) {
        this.theme.ChangeColor('warning');
        //this.theme.ChangeSipData(sessionStorage.getItem("current_number")+" is Wrong Number.(EC:"+response.statusCode+")");  
        this.theme.ChangeSipData("User is Unregistered");
        if (parseInt(sessionStorage.getItem("isdial")) == 1) {
          this.theme.StartAutodial(1);
        }
      }
      if (response.statusCode == 404) {
        this.theme.ChangeColor('warning');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Wrong Number");
        if (parseInt(sessionStorage.getItem("isdial")) == 1) {
          this.theme.StartAutodial(1);
        }
      }
      if (response.statusCode == 484) {
        this.theme.ChangeColor('warning');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Wrong Number");
        if (parseInt(sessionStorage.getItem("isdial")) == 1) {
          this.theme.StartAutodial(1);
        }
      }
      this.theme.showDialpad(false);
      this.theme.ChangeEvent(0);
      console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");

    });

    session.on('cancel', () => {
      sessionStorage.setItem('isdial', (1).toString());
      clearInterval(myTimer);

      // this.theme.ChangeColor('warning');
      // this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Rejected");
      // this.theme.showDialpad(false);
      // this.theme.ChangeEvent(0);
    });

    session.on('bye', (request) => {
      console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@" + request.method + "@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");
      console.log(request.method);
      sessionStorage.setItem('isdial', (1).toString());
      clearInterval(myTimer);

      if (request.method == "BYE") {
        this.theme.ChangeColor('red');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Disconnected");
        this.theme.GetBalance(true);
        if (parseInt(sessionStorage.getItem("isdial")) == 1) {
          this.theme.StartAutodial(1);
        }
      }
      console.log(request.statusCode);
      console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");
      this.theme.GetBalance(true);
      this.theme.showDialpad(false);
      this.theme.ChangeEvent(0);
    });

    session.on('trackAdded', () => {

    });

    session.on('accepted', (data) => {

      console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@" + data.statusCode + "@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");
      console.log(data.reasonPhrase);
      console.log(data.statusCode);
      clearInterval(myTimer);
      var pc = session.sessionDescriptionHandler.peerConnection;
      sessionStorage.setItem('isdial', (0).toString());

      if (data.statusCode == 200) {
        this.audio.pause();
        this.theme.ChangeColor('green');
        this.theme.ChangeSipData(sessionStorage.getItem("current_number") + " is Connected");
        this.theme.showDialpad(true);

        var remoteStream = new MediaStream();
        pc.getReceivers().forEach(function (receiver) {
          remoteStream.addTrack(receiver.track);
        });
        this.remoteAudio.srcObject = remoteStream;
        this.remoteAudio.play();

        // Gets local tracks
        var localStream = new MediaStream();
        pc.getSenders().forEach(function (sender) {
          localStream.addTrack(sender.track);
        });
        this.localAudio.srcObject = localStream;
        this.localAudio.play();
        sessionStorage.setItem("phonetype", "0");
      }
      console.log("/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/");
    });
  }

  reState(): void {
    this.theme.ChangeColor('green');
  }

 
 }